// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-cta-container__MaBsuPgu{display:flex;margin:16px 0 0 0}.mp-cta-container__MaBsuPgu .mp-primary-cta__FPmNp0gp{margin-left:auto}.mp-dismiss__LhwIjHUl{color:var(--primary-text-color);font-weight:400;margin:18px 0 18px 0}.mp-tour-body__NTD31vhw{font-size:14px;line-height:18px}.mp-tour-body__NTD31vhw .mp-title__YgQRfdON{font-size:16px;line-height:22px;margin:0 0 8px 0}.mp-tour-body__NTD31vhw .mp-markdown__hGDFRdcp{font-weight:400}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mpCtaContainer": "mp-cta-container__MaBsuPgu",
	"mpPrimaryCta": "mp-primary-cta__FPmNp0gp",
	"mpDismiss": "mp-dismiss__LhwIjHUl",
	"mpTourBody": "mp-tour-body__NTD31vhw",
	"mpTitle": "mp-title__YgQRfdON",
	"mpMarkdown": "mp-markdown__hGDFRdcp"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
